import { Link, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined'
import ContentContainer from '../../areas/layout/content-container'
import { faqs } from './faqs'
import {
  PageWrapper,
  HeroSection,
  Logo,
  LogoIcon,
  Title,
  Tagline,
  Section,
  SectionTitle,
  ContactCard,
  ContactIcon,
  ContactEmail,
  ContactNote,
  ReportRow,
  FaqWrapper,
  FaqAccordion,
  FaqQuestion,
  FaqAnswer,
  ClosingText,
  InlineLink,
} from './help-page.styles'

const SUPPORT_EMAIL = 'support@movieception.com'

const HelpPage = () => {
  return (
    <ContentContainer>
      <PageWrapper>
        <HeroSection>
          <Logo>
            <LogoIcon />
            <Title>Help & Support</Title>
          </Logo>
          <Tagline>
            Need a hand? Reach out to us directly, or check the answers to the
            most common questions below.
          </Tagline>
        </HeroSection>

        <Section>
          <SectionTitle>Contact us</SectionTitle>
          <ContactCard>
            <ContactIcon>
              <EmailOutlinedIcon />
            </ContactIcon>
            <ContactEmail href={`mailto:${SUPPORT_EMAIL}`} underline='hover'>
              {SUPPORT_EMAIL}
            </ContactEmail>
            <ContactNote>
              Questions, feedback, account issues - email us and we usually reply
              within 2-3 days.
            </ContactNote>
            <ReportRow>
              <BugReportOutlinedIcon />
              Reporting a bug? Include what you did, what you expected, and a
              screenshot if you can - it helps us fix it faster.
            </ReportRow>
          </ContactCard>
        </Section>

        <Section>
          <SectionTitle>Frequently asked questions</SectionTitle>
          <FaqWrapper>
            {faqs.map((faq) => (
              <FaqAccordion key={faq.question} disableGutters>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <FaqQuestion>{faq.question}</FaqQuestion>
                </AccordionSummary>
                <AccordionDetails>
                  <FaqAnswer>{faq.answer}</FaqAnswer>
                </AccordionDetails>
              </FaqAccordion>
            ))}
          </FaqWrapper>
        </Section>

        <Section>
          <ClosingText>
            Still stuck? Email us at{' '}
            <Link href={`mailto:${SUPPORT_EMAIL}`} underline='hover'>
              {SUPPORT_EMAIL}
            </Link>
            , or take the full tour on the{' '}
            <InlineLink to='/guide'>Guide page</InlineLink>.
          </ClosingText>
        </Section>
      </PageWrapper>
    </ContentContainer>
  )
}

export default HelpPage
